import {store} from '@/store';
import {userAtom} from '@/store/user';
import {buildMbApiUrl, fetchWithTimeout} from '@/util/request-utils';
import {type Category} from '@/types/categories';

export async function getCategories(): Promise<Category[]> {
    const user = store.get(userAtom);
    if (!user?.auth_token) {
        return [];
    }

    const url = buildMbApiUrl('/pg_libraries.json', {
        auth_token: user.auth_token,
    });
    const response = await fetchWithTimeout(url);

    if (!response.ok) {
        return [];
    }

    return response.json();
}
